/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductionPeriod } from '../../models/production-period';

export interface GetOpenPeriods$Params {
  workCenterId: number;
}

export function getOpenPeriods(http: HttpClient, rootUrl: string, params: GetOpenPeriods$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductionPeriod>>> {
  const rb = new RequestBuilder(rootUrl, getOpenPeriods.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProductionPeriod>>;
    })
  );
}

getOpenPeriods.PATH = '/api/v1/WorkCenter/{workCenterId}/GetOpenPeriods';
